import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { queryClient } from 'src/core/react-query';
import type { Group } from 'src/core/types';

import axios from './axios';

export interface UseMutateGroupVariables {
  id: number;
  members?: { id: number; email: string | null }[];
  title?: string;
}

export interface UseMutateGroupData extends Group {}

export function useMutateGroup() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    UseMutateGroupData,
    AxiosError<never>,
    UseMutateGroupVariables
  >(
    (variables) => {
      return axios
        .put<UseMutateGroupData>(
          `/posht/ashena/groups/${variables.id}/`,
          variables,
        )
        .then((res) => res.data);
    },
    {
      onError: () => {
        enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
      },
      onSettled: (data, error, variables, context) => {
        queryClient.invalidateQueries(['group', variables.id]);
        queryClient.invalidateQueries('groups');
      },
      onSuccess: () => {
        enqueueSnackbar(t('operation.successful'), { variant: 'success' });
      },
    },
  );
}
